import { gql } from '@apollo/client';

export const LIST_USERS = gql`
  query ListUsers($limit: Int = 50, $customsTerritories: [String!]!) {
    user {
      list(limit: $limit, customsTerritories: $customsTerritories) {
        items {
          id
          name
          email
          avatarUrl
        }
      }
    }
  }
`;

export const GET_CURRENT_USER = gql`
  query GetCurrentUser {
    user {
      me {
        id
        name
        email
        avatarUrl
        settings {
          selectedTerritories
          availableTerritories
          uiSettings
        }
      }
    }
  }
`;

export const UPDATE_USER_TERRITORIES = gql`
  mutation ChangeUserSelectedTerritories($selectedTerritories: [String!]!) {
    changeUserSelectedTerritories(selectedTerritories: $selectedTerritories) {
      selectedTerritories
      availableTerritories
      uiSettings
    }
  }
`;


// Mutation to change user settings
export const CHANGE_USER_UI_SETTINGS = gql`
  mutation ChangeUserSettings($uiSettings: AWSJSON!) {
    changeUserSettings(uiSettings: $uiSettings) {
      uiSettings
    }
  }
`;

// Query to get current user settings
export const GET_USER_UI_SETTINGS = gql`
  query GetUserSettings {
    user {
      me {
        id
        name
        email
        settings {
          uiSettings
        }
      }
    }
  }
`;